var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetterJ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9387,
    cy: 11.8821,
    r: 11.3821,
    fill: "#F3F6ED",
    stroke: "#A2BE71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8806 15.337C13.3346 15.896 12.5806 16.182 11.6316 16.182C10.6826 16.182 9.94164 15.922 9.42164 15.389C8.90164 14.869 8.64164 14.193 8.64164 13.374C8.64164 13.062 8.68064 12.75 8.75864 12.425L9.85064 12.62C9.81164 12.867 9.78564 13.101 9.78564 13.322C9.78564 14.479 10.4486 15.207 11.6316 15.207C12.9446 15.207 13.5946 14.401 13.5946 12.802V6.965H14.6996V12.971C14.6996 13.985 14.4266 14.778 13.8806 15.337Z",
    fill: "#8EB052"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterJ);
export default __webpack_public_path__ + "static/media/letterJ.0e09c1c11e92ebd51b3e4eef43894a93.svg";
export { ForwardRef as ReactComponent };